import { AccommodationListCriteria } from "../objects/accommodationListCriteria";

export const EMPTY_SUB_MODULE_LIST_CRITERIA: AccommodationListCriteria = { order_by: 'name', search: '', order: 'asc', page: 1, page_size: 10 }